import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Rightpart.css";
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';
import { fetchUserAppAPI } from "../../utils/api";
import { ShimmerTable } from "react-shimmer-effects";

export default function PurchaseRight() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) {
      navigate("/login");
      return;
    }
    const parsedUser = JSON.parse(storedUser);

    const fetchOrders = async () => {
      try {
        setLoading(true);
        const res = await fetchUserAppAPI("equipments-list-order", {
          method: "POST",
          body: JSON.stringify({ user_id: parsedUser.user_id }),
        });
        if (res && res.status === 200 && Array.isArray(res.result)) {
          setOrders(res.result);
        }
      } catch (err) {
        console.error("Error fetching payment history:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [navigate]);

  const totalSpent = orders.reduce((sum, o) => sum + (parseFloat(o.order_grand_total) || 0), 0);
  const pendingOrdersCount = orders.filter(o => o.order_payment_status === 'Pending').length;
  const lastOrderDate = orders.length > 0 && orders[0].order_created 
    ? new Date(orders[0].order_created).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
    : 'N/A';

  return (
    <div className="outer-div-right">
      <div className="dashbord-right-section">
         <div className="content-dashborad-outer outer_main_payment_pg">
          <div className="iner-boxes-dr my_payment_box_sec">
            <div className="main-box-dr">
              <p>Total Spent</p>
              <div className="number-iconn">
                <h4>₹{totalSpent.toLocaleString('en-IN')}/-</h4>
                <div className="box-img-2 box-img">
                  <CurrencyRupeeOutlinedIcon/>
                </div>
              </div>
            </div>
            <div className="main-box-dr">
              <p>Pending Payments</p>
              <div className="number-iconn">
                <h4>{pendingOrdersCount} Order(s)</h4>
                <div className="box-img-3 box-img">
                  <CurrencyRupeeOutlinedIcon />
                </div>
              </div>
            </div>
            <div className="main-box-dr">
              <p>Last Activity</p>
              <div className="number-iconn">
                <h4>{lastOrderDate}</h4>
                <div className="box-img-4 box-img">
                  <CurrencyRupeeOutlinedIcon/>
                </div>
              </div>
            </div>
          </div>
        

          <div className='address-manager '>
            <div className='box-top'>
              <div className='sr-number'>
                <h4>Payment & Invoice History</h4>
              </div>
            </div>
            <div className=' billing-text'>
              <div className="table-dashbord table-responsive">
                {loading ? (
                  <div className="p-3">
                    <ShimmerTable row={4} col={6} />
                  </div>
                ) : orders.length === 0 ? (
                  <div className="text-center py-4 text-muted">No payment history available.</div>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th>Order No</th>
                        <th>Date</th>
                        <th>Payment Method</th>
                        <th>Amount</th>
                        <th>Payment Status</th> 
                        <th>Order Status</th> 
                      </tr>
                    </thead>

                    <tbody>
                      {orders.map((order) => {
                        const createdDate = order.order_created 
                          ? new Date(order.order_created).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
                          : '-';

                        return (
                          <tr key={order.order_id}>
                            <td>
                              <Link to={`/myorders?id=${order.order_no}`} style={{ color: '#13baac', textDecoration: 'none', fontWeight: 'bold' }}>
                                #{order.order_no}
                              </Link>
                            </td>
                            <td>{createdDate}</td>
                            <td>{order.order_payment_method || 'COD'}</td>
                            <td>₹{parseFloat(order.order_grand_total || 0).toLocaleString('en-IN')}</td>
                            <td>
                              <span className={`status ${(order.order_payment_status || 'Pending').toLowerCase()}`}>
                                {order.order_payment_status || 'Pending'}
                              </span>
                            </td>
                            <td>
                              <span className={`status ${(order.order_status || 'Pending').toLowerCase()}`}>
                                {order.order_status || 'Pending'}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}



// import React from "react";
// import "./Rightpart.css";
// import profile from "../assets/images/profile.png";
// import deshboardimg from "../assets/images/deshboard-img.png";
// import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

// export default function PurchaseRight() {
//   return (
//     <div className="outer-div-right">
//       <div className="dashbord-right-section">
//         <div className="dashbord-header">
//           <p className="title-dash">Purchase History</p>
//           <div className="profile-name">
//             <img src={profile} alt="" />
//             <div className="name-mail">
//               <h4>DEEPAK SHARMA</h4>
//               <p>Deepak@gmail.com</p>
//             </div>
//           </div>
//         </div>
//         <div className="content-dashborad-outer">
          
//           <div className="table-dashbord tabel-responsive">
//             <table>
//               <thead>
//                 <tr>
//                   <th>Order ID</th>
//                   <th>Order Status</th>
//                   <th>Date</th>
//                   <th>Number of Product</th>
//                   <th>Amount</th>
//                   <th>View</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 <tr>
//                   <td>Neworder#1236</td>
//                   <td>
//                     <span className="status placed">Placed</span>
//                   </td>
//                   <td>17-04-2026</td>
//                   <td>2</td>
//                   <td>30,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>Neworder#1236</td>
//                   <td>
//                     <span className="status dispatch">Dispatch</span>
//                   </td>
//                   <td>15-04-2026</td>
//                   <td>1</td>
//                   <td>10,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>Neworder#1236</td>
//                   <td>
//                     <span className="status packed">Packed</span>
//                   </td>
//                   <td>12-04-2026</td>
//                   <td>3</td>
//                   <td>5,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>Neworder#123</td>
//                   <td>
//                     <span className="status delivered">Delivered</span>
//                   </td>
//                   <td>18-04-2026</td>
//                   <td>5</td>
//                   <td>60,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>Neworder#1236</td>
//                   <td>
//                     <span className="status pending">Pending</span>
//                   </td>
//                   <td>1-04-2026</td>
//                   <td>8</td>
//                   <td>70,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

